import { Component } from '@angular/core';

@Component({
  selector: 'app-user-profile-seats-page',
  templateUrl: './user-profile-seats-page.component.html',
  styleUrls: ['./user-profile-seats-page.component.scss'],
})
export class UserProfileSeatsPageComponent {
  status = 'Active';

  isExpanded = false;

  bus_id = '';
  username = '';
  searchValue: any = { type: 'username', input: '' };

  searchValueChange() {
    if (this.searchValue.type === 'username') {
      this.username = this.searchValue.input;
    }

    if (this.searchValue.type === 'bus_id') {
      this.bus_id = this.searchValue.input;
    }
  }

  changeStatus(val: string) {
    this.status = val;

    this.searchValue = {
      type: 'username',
      input: '',
    };
  }
}
